"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var HeaderContainer_1 = require("./HeaderContainer");
var StorageAccountsListView_1 = require("./StorageAccountsListView");
var initializeStorageAccountsOption_1 = require("../actions/initializeStorageAccountsOption");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_filepicker_options_view_1 = require("owa-filepicker-options-view");
var owa_filepicker_store_1 = require("owa-filepicker-store");
var owa_fileprovider_store_1 = require("owa-fileprovider-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var ReactDOM = require("react-dom");
var AddStorageAccountCallout_1 = require("./AddStorageAccountCallout");
var owa_lightning_1 = require("owa-lightning");
var styles = require('./StorageAccountsFull.scss');
var StorageAccountsFull = /** @class */ (function (_super) {
    tslib_1.__extends(StorageAccountsFull, _super);
    function StorageAccountsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addAndSelectFileProviderAction = null;
        // Keeps track of whether there is already an account removal action going on
        _this.isAccountBeingRemoved = {};
        _this.getAddStorageAccountFunc = function (account) {
            return function () {
                // If we already have the action loaded then just execute it
                // otherwise make an asynchronous call to load it and then call it
                // which will trigger the popup blocker but its the fallback logic.
                if (_this.addAndSelectFileProviderAction) {
                    _this.addAndSelectFileProviderAction(account.type);
                }
                else {
                    owa_filepicker_store_1.lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
                        addAndSelectFileProvider(account.type);
                    });
                }
            };
        };
        _this.removeAccount = function (viewState) {
            var id = viewState.model.Id;
            if (!_this.isAccountBeingRemoved[id]) {
                // If there was no ongoing account removal action for the
                // corresponding account then initiate it. The reason we only
                // allow one removal action to be called at a time as otherwise
                // any other requests after the successful removal of account will fail
                // which might cause the removal failure dialog to open giving the impression
                // to user that removing the account failed.
                _this.isAccountBeingRemoved[id] = true;
                owa_filepicker_store_1.lazyRemoveFileProvider
                    .importAndExecute(viewState.model.Id)
                    .then(function () {
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                })
                    .catch(function () {
                    /* Ignore any error */
                    // Set the state back to false as the operation completed
                    _this.isAccountBeingRemoved[id] = false;
                });
            }
        };
        return _this;
    }
    StorageAccountsFull.prototype.componentDidMount = function () {
        var _this = this;
        // Initialize the addAndSelectFileProvider so that by the time user clicks it
        // we don't have to import it asynchornously and execute as that can cause
        // popup blocker to trigger
        owa_filepicker_store_1.lazyAddAndSelectFileProvider.import().then(function (addAndSelectFileProvider) {
            _this.addAndSelectFileProviderAction = addAndSelectFileProvider;
        });
        initializeStorageAccountsOption_1.default();
    };
    StorageAccountsFull.prototype.render = function () {
        var target;
        var _a = this.props, addableFileProvidersViewState = _a.addableFileProvidersViewState, fileProvidersViewState = _a.fileProvidersViewState, areFileProvidersLoaded = _a.areFileProvidersLoaded;
        var _b = this.getStorageAccountCategories(fileProvidersViewState), primaryAccounts = _b.primaryAccounts, secondaryAccounts = _b.secondaryAccounts;
        var providersToAddInfo = this.getStorageAccountToAdd(addableFileProvidersViewState);
        return areFileProvidersLoaded ? (React.createElement("div", { className: styles.container },
            React.createElement("div", null,
                providersToAddInfo.length !== 0 && (React.createElement("div", null,
                    React.createElement(HeaderContainer_1.default, { className: styles.fileProvidersToAddContainer, ref: function (ref) { return (target = ReactDOM.findDOMNode(ref)); }, header: owa_options_strings_1.default.options_storageAccounts_addAccountHeader },
                        React.createElement(owa_filepicker_options_view_1.FileProvidersToAddListView, { providersToAddInfo: providersToAddInfo })),
                    React.createElement(AddStorageAccountCallout_1.AddStorageAccountCallout, { lid: owa_lightning_1.LightningId.AddStorageAccountCallout, when: function (lightup) { return setTimeout(lightup, 500); }, target: function () { return target; } }))),
                React.createElement(StorageAccountsListView_1.default, { header: owa_options_strings_1.default.options_storageAccounts_primaryAccount, storageAccounts: primaryAccounts }),
                React.createElement(StorageAccountsListView_1.default, { header: owa_options_strings_1.default.options_storageAccounts_otherAccounts, storageAccounts: secondaryAccounts, onRemoveHandler: this.removeAccount })))) : (React.createElement(Spinner_1.Spinner, null));
    };
    StorageAccountsFull.prototype.getStorageAccountToAdd = function (accountsToAdd) {
        var _this = this;
        return accountsToAdd.map(function (account) {
            return {
                providerType: account.type,
                onClick: _this.getAddStorageAccountFunc(account),
            };
        });
    };
    StorageAccountsFull.prototype.getStorageAccountCategories = function (providers) {
        var _a = providers.filter(function (p) { return p.type !== 4 /* Mailbox */; }), primaryProvider = _a[0], secondaryProviders = _a.slice(1);
        return {
            primaryAccounts: primaryProvider ? [primaryProvider] : [],
            secondaryAccounts: secondaryProviders,
        };
    };
    StorageAccountsFull = tslib_1.__decorate([
        react_1.reactive({
            fileProvidersViewState: function () { return owa_fileprovider_store_1.store.fileProvidersViewState; },
            addableFileProvidersViewState: function () { return owa_fileprovider_store_1.store.addableFileProvidersViewState; },
            areFileProvidersLoaded: function () { return owa_fileprovider_store_1.store.areFileProvidersLoaded; },
        })
    ], StorageAccountsFull);
    return StorageAccountsFull;
}(React.Component));
exports.default = StorageAccountsFull;
//# sourceMappingURL=StorageAccountsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-storage-accounts-option/lib/components/StorageAccountsFull.js
// module id = 4987
// module chunks = 2